<template>
    <div class="p-4 relative text-center " ref="stat">
        <div class="h-32 w-32 bg-gray-200 rounded-full inline-block ">
            <i class="pt-10 block text-5xl text-red_n" :class="icon"></i>
            <label class="mt-8 pt-4 block">{{title}}</label>
        </div>
    </div> 
</template>

<script>
    export default {
        props:{
            'number':{default:0}, 
            'title':{default:""},
            'icon':{default:""},
            'color':{default:""}
        },

        data: function(){
            return {
                ammount:0,
                interval:false
            }
        },
        mounted ()
        {
            this.animateNumber();
        }, 
        methods:{
            getPourcentage() {
                return this.number * 100;
            },
            animateNumber () {
                
                clearInterval(this.interval);
                this.interval = window.setInterval(function(){
                    if (this.ammount < (this.number * this.$refs.stat.clientWidth))
                        this.ammount += 4;
                }.bind(this), 10);
            },
        }
    }
</script>
